import React, { useRef, useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLanguage } from '../context/LanguageContext';

function Program() {
  const { t } = useLanguage();
  const sliderRef = useRef(null);
  const [slidesToShow, setSlidesToShow] = useState(3.1);
  const [showArrows, setShowArrows] = useState(true);

  // Manually handle responsive breakpoints to ensure they work
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSlidesToShow(1.1);
        setShowArrows(false);
      } else if (window.innerWidth < 1024) {
        setSlidesToShow(2.1);
        setShowArrows(true);
      } else {
        setSlidesToShow(3.1);
        setShowArrows(true);
      }
    };

    // Set initial value
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pricingOptions = t.program.levels;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: showArrows,
    adaptiveHeight: false
  };

  // Handle horizontal scroll
  const handleWheel = (e) => {
    if (e.deltaX !== 0) {
      e.preventDefault();
      if (e.deltaX > 0) {
        sliderRef.current?.slickNext();
      } else {
        sliderRef.current?.slickPrev();
      }
    }
  };

  return (
    <section id="program">
      <div className="container">
        <h2 className="section-title">{t.program.title}</h2>
      </div>
      
      <div className="program-carousel-wrapper" onWheel={handleWheel}>
        <Slider ref={sliderRef} {...settings} className="program-carousel">
          {pricingOptions.map((option, index) => (
            <div key={index}>
              <div className="carousel-slide">
                <div className={`price-card ${option.featured ? 'featured' : ''}`}>
                    <h3 style={{marginBottom: '20px' }}>{option.title}</h3>

                    <svg width="60" height="20" style={{ margin: '0px auto', marginBottom: '20px', display: 'block' }}>
                    <rect width="60" height="15" fill={option.color} rx="4" />
                  </svg>
                  <p className="mission-intro slogan"  style={{fontSize: '1.1rem', marginTop: '10px' }}>
                        <span>{option.slogan}</span>
                    </p>
                  
                  
                  {option.psychologicalgoals && (
                    <>
                      <p className="section-skills">{t.program.sections.psychologicalgoals}</p>
                      <ul className="mission-list" style={{ textAlign: 'left' }}>
                        {option.psychologicalgoals.map((goal, i) => (
                          <li key={i}>{goal}</li>
                        ))}
                      </ul>
                    </>
                  )}

                  {option.requirements && (
                    <>
                      <p className="section-skills" style={{ marginTop: '40px' }}>{t.program.sections.requirements}</p>
                      <ul className="mission-list" style={{ textAlign: 'left' }}>
                        {option.requirements.map((assess, i) => (
                          <li key={i}>{assess}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  
                  {option.technicalskills && (
                    <>
                      <p className="section-skills" style={{ marginTop: '40px' }}>{t.program.sections.technicalskills}</p>
                      <ul className="mission-list" style={{ textAlign: 'left' }}>
                        {option.technicalskills.map((skill, i) => (
                          <li key={i}>{skill}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  
                  {option.scenarios && (
                    <>
                      <p className="section-skills" style={{ marginTop: '40px' }}>{t.program.sections.scenarios}</p>
                      <ul className="mission-list" style={{ textAlign: 'left' }}>
                        {option.scenarios.map((scenario, i) => (
                          <li key={i}>{scenario}</li>
                        ))}
                      </ul>
                    </>
                  )}
                  
                  {option.assessment && (
                    <>
                      <p className="section-skills" style={{ marginTop: '40px' }}>{t.program.sections.assessment}</p>
                      <ul className="mission-list" style={{ textAlign: 'left' }}>
                        {option.assessment.map((assess, i) => (
                          <li key={i}>{assess}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Program;
